/**
 * Created by neo on 07.05.21.
 */
import { makeAutoObservable } from 'mobx';

export type SsmlVoiceGender = 'MALE' | 'FEMALE' | 'NEUTRAL';

export type GoogleTtsVoice = {
  languageCode: string;
  gender: SsmlVoiceGender;
};

export function createGoogleTtsVoice(json?: Partial<GoogleTtsVoice>): GoogleTtsVoice {
  return makeAutoObservable({
    languageCode: json?.languageCode ?? 'de-DE',
    gender: json?.gender ?? 'MALE',
  });
}
